import React from "react";
import image1 from "../img/The Vakzthari Operator&&Cycle[11]---Blending textures over AI generated images on Adobe Photoshop___2025-03[[19]].png"
export default function Machine_1_2_3() {
  return (
    <div className="panel-block">
     

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={image1}
          alt="1.2.3 · THE OPERATOR"
        />
      </div>

      <div className="panel-container-right">
         <h2>1.2.3 · THE OPERATOR</h2>
        <p>The Vakzthari Operator is not a figure.</p>
    <p>It is a stance beyond the panel of conformity.</p>
    <p>A point of view on how to operate through the noise.</p>
    <p>How to call the Machine when the Fog is all you see.</p>
    <p>If you are here, maybe you are an Operator.</p>
      </div>
    </div>
  );
}
